module.exports = __webpack_public_path__ + "img/1.4c109c9a.png";